import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import TableDetail from '../fw/TableDetail.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {defaultPageSize} from '../fw/PagingGrid.react';
import {FormattedMessage, IntlShape} from 'react-intl';
import types from '../../common/model-api/types';
import ChannelHeader from '../channels/ChannelHeader.react';
import JsonTable from '../view/box/system/JSONTableNew.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

interface DataSetViewProps {
 relay: object;
 user: User;
}

class DataSetView extends React.Component<DataSetViewProps> {

    typeName = 'dataSets';

    static propTypes = {
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const data = this.props.user.organisation.channel.dataSet;
        let type = types[this.typeName];
        let name = type._metadata.defaultTitle(data);

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['channels'], data: this.props.user.organisation.channel},
                {type: types['organisations'], data: this.props.user.organisation}]
            }
            className="CachedData"
            title={data.entityDef.name}>
                <ChannelHeader data={data} organisation={this.props.user.organisation}>
                    <h3><FormattedMessage defaultMessage="Cached data:" id="application.connectedTitle" /> {name}</h3>
                </ChannelHeader>

                <TableDetail columns={['storeInfo.status']} data={data} metadata={type} />

                <div className="row">
                    {this.props.user.organisation.channel.dataSet.viewsWithData.edges.map(({node}, idx) => {
                        if (node.view && node.view.entityViewDef) {
                            node.view.entityViewDef.filter = JSON.parse(node.data || '[]').length;
                        }

                        return (
                            <JsonTable
                                isConfigurable={false}
                                key={idx}
                                viewWithData={node}
                            />
                        );
                    })}
                </div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(DataSetView, (props) => {
    return props.user.organisation && props.user.organisation.channel && props.user.organisation.channel.dataSet;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        dataSetId: '',
        first: defaultPageSize,
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    name,
                    channel(id: $channelId) {
                        id,
                        name,
                        channelDef {
                            id,
                            name
                        },
                        dataSet(id: $dataSetId) {
                            channelDef_id,
                            channelDef {
                                id,
                                name,
                                icon
                            },
                            storeInfo {
                                id,
                                status,
                                hasAnyData
                            },
                            channel_id,
                            channelEntityDef_id,
                            entityDef_id,
                            sourceDef_id,
                            organisation_id,
                            id,
                            channel {
                                id,
                                name,
                            },
                            entityDef {
                                id,
                                name,
                            },
                            sourceDef {
                                id,
                                name,
                            },
                            viewsWithData(first: $first) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        view {
                                            id,
                                            realId,
                                            template,
                                            handler,
                                            entityViewDef {
                                                id,
                                                template,
                                                title,
                                                handler,
                                                entityDef {
                                                    id,
                                                }
                                            }
                                        },
                                        entityDef {
                                            id,
                                            key,
                                            name,
                                            allFieldDefs(first: 200) {
                                                edges {
                                                    node {
                                                        id,
                                                        realId,
                                                        name,
                                                        shortName,
                                                        description,
                                                        type,
                                                    }
                                                }
                                            }
                                        },
                                        data,
                                        addon,
                                        error,
                                        cachingRequired,
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
});
